import { bool } from "prop-types";
import { useMemo } from "react";
import { observer } from "mobx-react";
import { PriceFormats, MinAvgMaxKeys } from "@repo/utils";
import { getProfitColor } from "@utils";
import { useEstimateStructure } from "@tools";
import { TotalContainer } from "../components";
import { useTheme } from "@material-ui/core/styles";

export const TotalProfit = observer(( containerProps ) => {
  const theme = useTheme();
  const structure = useEstimateStructure();
  
  const {
    settings,
    displayTotalCompanyProfit,
    displayTotalCompanyProfitMax,
    showMaxTotalCompanyProfit,
    totalCompanyProfitability,
  } = structure;
  
  const { currencyObj, maxValuesAsBuffer, priceFormat } = settings;
  
  const color = useMemo(() => (
    getProfitColor(totalCompanyProfitability, theme)
  ), [totalCompanyProfitability, theme]);
  
  const handleProfitChange = (profit, isMax) => {
    let key = MinAvgMaxKeys.AVG;
    if(isMax)
      key = MinAvgMaxKeys.MAX;
    else if(!maxValuesAsBuffer && showMaxTotalCompanyProfit)
      key = MinAvgMaxKeys.MIN;
    
    structure.setTotalCompanyProfit(profit, key);
  };
  
  return (
    <TotalContainer
      totalName="profit"
      min={displayTotalCompanyProfit}
      max={displayTotalCompanyProfitMax}
      showMaxValue={showMaxTotalCompanyProfit}
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      style={{color}}
      editable
      onValueChange={handleProfitChange}
      maxValue={10000000}
      showDecimals
      allowNegative
      applySuffixSpacing
      {...containerProps}
    />
  );
})

TotalProfit.propTypes = {
  compact: bool,
  showDivider: bool,
}